import { IChildProp } from "@intelligence/components/Form/type";

const STORE_RANK_MOBILE_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'special_datePickerSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'datePicker',
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

const STORE_RANK_PC_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'chart',
    enumTargetType: 'downloadMainCategory',
    type: 'dynamicText',
  },
  {
    enumKey: 'basicInformationOptional',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'special_dataCalculationChange',
    enumTargetType: 'downloadMainCategory',
    type: 'switch',
    isDefault: true,
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportSpecialSelected',
        enumTargetType: 'downloadOther',
      }
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

export default {
  storeRankMobile: STORE_RANK_MOBILE_DOWNLOAD_SET,
  storeRankPC: STORE_RANK_PC_DOWNLOAD_SET,
  storeRankConsole: STORE_RANK_MOBILE_DOWNLOAD_SET,
};
